import { useAgentIsV2 } from '@/pages/avatar/hooks/useAgentIsV2';
import { PlaygroundContainerV1 } from './PlaygroundContainerV1';
import { PlaygroundContainerV2 } from './PlaygroundContainerV2';

interface Props {
    enableStitchSelection?: boolean;
    agentId: string;
}

export const PlaygroundContainer = ({ agentId, enableStitchSelection }: Props) => {
    const isV2 = useAgentIsV2(agentId);

    if (isV2) {
        return <PlaygroundContainerV2 agentId={agentId} />;
    }

    return <PlaygroundContainerV1 agentId={agentId} enableStitchSelection={enableStitchSelection} />;
};
